module.exports = __webpack_public_path__ + "static/img/10areaA_02.80dc47c.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/10areaA_02.png
// module id = 995
// module chunks = 1